<div class="toggle-container">
  <p>Select a chat bot mode:</p>

  <div class="mode-container">
    @for (mode of modes; track mode) {
      <input type="radio" name="chatMode" [value]="mode" [(ngModel)]="selectedMode" (change)="onModeChange(mode)" />
      <p>{{ mode }}</p>
    }
  </div>
</div>
